import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import GroupQuestions from './GroupQuestions';
import { getQuestionPositions } from '../helpers';
/**
 *  Группа вопросов
 *  обратной связи по заказу
 */
class GroupQuestionsContainer extends PureComponent {
  radioChangeHandler = question => answer => {
    const {
      changeHandler
    } = this.props;
    changeHandler({
      question,
      answer
    });
  };
  textareaChangeHandler = question => ({
    target: {
      value
    }
  }) => {
    const {
      changeHandler
    } = this.props;
    changeHandler({
      question,
      answer: {
        ...question.answers[0],
        value
      }
    });
  };
  checkboxChangeHandler = (question, answer) => ({
    target: {
      checked
    }
  }) => {
    const {
      changeHandler
    } = this.props;
    changeHandler({
      question,
      answer: {
        ...answer,
        value: checked
      }
    });
  };
  render() {
    const {
      questions = [],
      ...rest
    } = this.props;
    const {
      top,
      left,
      bottom,
      right
    } = getQuestionPositions(questions);
    return /*#__PURE__*/React.createElement(GroupQuestions, {
      ...rest,
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      radioChangeHandler: this.radioChangeHandler,
      textareaChangeHandler: this.textareaChangeHandler,
      checkboxChangeHandler: this.checkboxChangeHandler
    });
  }
}
GroupQuestionsContainer.propTypes = {
  /** Вопросы */questions: PropTypes.arrayOf(PropTypes.shape({
    /** Идентификатор вопроса */id: PropTypes.number
  })),
  /** Изменение значения вопроса */changeHandler: PropTypes.func
};
export default GroupQuestionsContainer;